import moment from 'moment';
import { CISO_SAMC_API, TOOLS_API } from '@/api';

const state = {
  tableData: [],
  selectedRows: [],
  rowsStatus: {
    invalidRows: [],
    validRows: [],
  },
  headers: [],
  validationColumns: {
    name: 'ValidationColumns',
    columns: [],
    options: {
      filterRow: true,
      filterHeader: true,
    },
  },
  errorMessages: [],
  errorMessageVisible: false,
};

const actions = {
  async fetchBatchData({ commit }, args) {
    const params = {
      scs: args.coordinatorListSelected ? args.coordinatorListSelected.join(',') : null,
      startDate: args.tradeDateRangeSelected[0].toISOString(),
      endDate: args.tradeDateRangeSelected[1].toISOString(),
      dateType: args.dateTypeSelected,
      statementFlag: args.statementFlagSelected,
    };
    try {
      const { data: { data } } = await CISO_SAMC_API.get('/sub-alloc-batch', { params });
      if (Array.isArray(data)) {
        const validations = data[0].validationChecks.map((vc) => vc.validationType);
        data.forEach((element) => {
          if (element.validationChecks.some((vc) => vc.status === false)) {
            element.validationMessage = 'This row has failed some pre-calculation validations.';
          }
        });
        commit('setTableData', data);
        commit('setValidationColumns', validations);
      }
    } catch (err) {
      console.error(err);
      this.$notify(`Failed to load ${ args.runTypeSelected } Batch Data`, 'error');
    }
  },
  async runSubAllocBatch({ state, commit }, records) {
    const batch = records.map((record) => ({
      calculationType: (() => {
        const str = record.fileType.split('_')[0];
        return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
      })(), // need calcType in pascal case because middleware parses as an enum, exact case needs to match
      fileType: record.fileType,
      settlementCycle: record.settlementCycle,
      coordinators: [record.sc],
      entities: [record.sc],
      skipValidations: record.skipValidations,
      startDate: moment(record.flowDate).toISOString(),
      endDate: moment(record.flowDate).toISOString(),
    }));

    const endPoint = 'transmission-calc';

    try {
      const { data: { valid } } = await TOOLS_API.post(`/legacy-process/batch/${endPoint}`, { batch });

      if (valid) this.$notify('Successfully initiated calculations', 'success');
    } catch (err) {
      console.error(err);
      const messages = err.response?.data?.messages;
      if (messages) {
        commit('setErrorMessages', messages);
      } else {
        this.$notify('Failed to initiate calculations. If the issue persists, please contact PSCS support.',
          'error');
      }
    }
  },
};

const mutations = {
  setTableData(state, value) {
    state.tableData = value;
    state.selectedRows = [];
  },
  setValidationColumns(state, value) {
    const validationColumns = [];
    value.forEach((element) => {
      validationColumns.push({
        label: element,
        prop: element,
        filterable: true,
        sortable: true,
        dataType: 'boolean',
        width: 50,
      });
    });
    state.validationColumns.columns = validationColumns;
  },
  setSelectedRows(state, value) {
    state.selectedRows = value;
  },
  setRowsStatus(state, value) {
    state.rowsStatus.invalidRows = value.invalidRows;
    state.rowsStatus.validRows = value.validRows;
  },
  setErrorMessages(state, value) {
    state.errorMessages = [...new Set(value)];
    state.errorMessageVisible = true;
  },
  setErrorMessagesVisible(state, value) {
    state.errorMessageVisible = value;
  },
  setHeaders(state, value) {
    state.headers = value;
  },
  reset(state) {
    state.selectedRows = [];
    state.tableData = [];
    state.rowsStatus.invalidRows = [];
    state.rowsStatus.validRows = [];
    state.headers = [];
    state.errorMessages = [];
    state.errorMessageVisible = false;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};